










import { vxm } from '../store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OtpValidationToken } from '../models/userdata/otptoken';
import OtpVerification from './OtpVerification.vue';
import { config } from '@vue/test-utils';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'Verfication',
  components: {
    OtpVerification,
  },
})
export default class Verfication extends Vue {
  private otpToken: OtpValidationToken = new OtpValidationToken();
  $wlToastr: any;
  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get phoneNumber(): string {
    return vxm.users.myUserProfile.phoneNum;
  }
  continueOTP() {
    const vm = this;
    this.otpToken.userIdStr = vxm.users.myUserProfile.email;
    this.otpToken.failureCount = '0';
    this.otpToken.failedAttemptCount = 0;
    if (vm.isLoggedIn) {
      const respPromise: any = vxm.users.validateOTP(vm.otpToken);
      Promise.all([respPromise]).then((values) => {
        if (values[0].status === 'success') {
          vm.$wlToastr(
            'success',
            vm.$t('verfication.otp.success'),
            vm.$t('verification.toast.title'),
          );
        } else {
          const errorMessage = values[0].error;
          vm.$wlToastr('error', errorMessage, vm.$t('verification.toast.title'));
        }
      });
    } else {
      const respPromise: any = vxm.users.anonValidateOTP(vm.otpToken);
      Promise.all([respPromise]).then((values) => {
        if (values[0].status === 'success') {
          vm.$wlToastr(
            'success',
            vm.$t('verfication.otp.success'),
            vm.$t('verification.toast.title'),
          );
        } else {
          const errorMessage = values[0].error;
          vm.$wlToastr('error', errorMessage, vm.$t('verification.toast.title'));
        }
      });
    }
  }

  continueEventHandler(otpTokenData) {
    console.log('continue');
    this.otpToken = otpTokenData;
    if (!this.otpToken.otp) {
      this.$wlToastr(
        'error',
        this.$t('verification.otp.validation.message'),
        this.$t('verification.toast.title'),
      );
    } else if (this.otpToken.otp.length < 5) {
      this.$wlToastr(
        'error',
        this.$t('verification.otp.validation.message'),
        this.$t('verification.toast.title'),
      );
    } else {
      this.continueOTP();
    }
  }
  skipEventHandler() {
    console.log('skip');
    router.push({ name: 'Findjobs' });
  }
  resendEventHandler() {
    console.log('resend');
    const vm = this;
    const respPromise: any = vxm.users.sendOTP();
    Promise.all([respPromise]).then((values) => {
      if (values[0].status === 'success') {
        vm.$wlToastr('info', vm.$t('resent-otp-success-msg'), vm.$t('verification.toast.title'));
      } else {
        const errorMessage = values[0].error;
        vm.$wlToastr('error', errorMessage, vm.$t('verification.toast.title'));
      }
    });
  }
}
